/* Brand header (2026 redesign): pinned main row, disclosure mega menus, mobile drawer and predictive search.
   One header instance is live at a time; the theme editor re-renders the section, so it is rebuilt on shopify:section:load. */
(function () {
  'use strict';
  var docEl = document.documentElement;
  var desktop = window.matchMedia('(min-width: 1000px)');
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var current = null;

  function createHeader(root) {
    var main = root.querySelector('.bh-main');
    var util = root.querySelector('[data-bh-util]');
    var nav = root.querySelector('[data-bh-nav]');
    var form = root.querySelector('[data-bh-search]');
    var searchToggle = root.querySelector('[data-bh-search-toggle]');
    var drawer = root.querySelector('[data-bh-drawer]');
    var sheet = drawer && drawer.querySelector('[data-bh-drawer-sheet]');
    var toggles = Array.prototype.slice.call(root.querySelectorAll('[data-bh-mega-toggle]'));
    var fixed = false;
    var api = { root: root };

    /* ---------- Warehouse cart: count updates, cart page quantity buttons, cart:refresh on Back ---------- */
    if (typeof window.Cart === 'function') {
      try {
        if (window.__bhCart && typeof window.__bhCart.destroy === 'function') window.__bhCart.destroy();
        window.__bhCart = new window.Cart(root.querySelector('.bh-actions'), { useStickyHeader: true });
      } catch (err) { window.__bhCart = null; }
    }

    /* ---------- Pinned main row ---------- */
    function pinnedHeight() { return desktop.matches ? 72 : 56; }
    function measure() {
      // The spacer takes the unpinned row's height; measure it without the pinned class, in the same frame
      var was = root.classList.contains('bh--fixed');
      if (was) root.classList.remove('bh--fixed');
      root.style.setProperty('--bh-main-h', main.offsetHeight + 'px');
      if (was) root.classList.add('bh--fixed');
    }
    function setHeaderVars() {
      var h = fixed ? main.offsetHeight : pinnedHeight();
      docEl.style.setProperty('--header-is-sticky', '1');
      docEl.style.setProperty('--header-height', (h || pinnedHeight()) + 'px');
    }
    function setSearchToggle(open) {
      if (!searchToggle) return;
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      searchToggle.setAttribute('aria-label', open ? 'Hide search' : 'Show search');
    }
    function onScroll() {
      var threshold = util ? util.offsetHeight : 0;
      var shouldFix = window.scrollY > threshold + 4;
      if (shouldFix === fixed) return;
      if (shouldFix) measure();
      fixed = shouldFix;
      root.classList.toggle('bh--fixed', fixed);
      if (fixed) {
        // Keep the phone search row open if someone is typing in it
        if (form && form.contains(document.activeElement)) { root.classList.add('bh--search-open'); setSearchToggle(true); }
      } else {
        root.classList.remove('bh--search-open'); setSearchToggle(false);
      }
      if (!nav.contains(document.activeElement) && !nav.matches(':hover')) closeAllMegas(false);
      setHeaderVars();
    }
    function onResize() { measure(); setHeaderVars(); }
    api.onScroll = onScroll;
    api.onResize = onResize;

    /* ---------- Mega menus (disclosure pattern) ---------- */
    function isOpen(btn) { return btn.getAttribute('aria-expanded') === 'true'; }
    function panelFor(btn) { return document.getElementById(btn.getAttribute('aria-controls')); }
    function openMega(btn) {
      toggles.forEach(function (other) { if (other !== btn) closeMega(other, false); });
      btn.setAttribute('aria-expanded', 'true');
      var p = panelFor(btn); if (p) p.hidden = false;
    }
    function closeMega(btn, returnFocus) {
      if (!isOpen(btn)) return;
      btn.setAttribute('aria-expanded', 'false');
      var p = panelFor(btn); if (p) p.hidden = true;
      if (returnFocus) btn.focus();
    }
    function closeAllMegas(returnFocus) {
      toggles.forEach(function (btn) { closeMega(btn, returnFocus && isOpen(btn)); });
    }
    toggles.forEach(function (btn) {
      var item = btn.parentElement;
      var openTimer, closeTimer, hoverOpened = false;
      btn.addEventListener('click', function () {
        // Hover already opened it: the click confirms rather than closes
        if (hoverOpened && isOpen(btn)) { hoverOpened = false; return; }
        hoverOpened = false;
        if (isOpen(btn)) closeMega(btn, false); else openMega(btn);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault(); openMega(btn);
          var first = panelFor(btn).querySelector('a'); if (first) first.focus();
        }
      });
      item.addEventListener('mouseenter', function () {
        if (!canHover.matches || !desktop.matches) return;
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () { if (!isOpen(btn)) { openMega(btn); hoverOpened = true; } }, 120);
      });
      item.addEventListener('mouseleave', function () {
        if (!canHover.matches || !desktop.matches) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          if (item.contains(document.activeElement)) return;
          hoverOpened = false; closeMega(btn, false);
        }, 220);
      });
      item.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !item.contains(e.relatedTarget)) { hoverOpened = false; closeMega(btn, false); }
      });
    });

    /* ---------- Mobile drawer ---------- */
    var lastOpener = null;
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
    function drawerOpen() { return !!drawer && !drawer.hidden; }
    function visibleFocusables() {
      return Array.prototype.slice.call(sheet.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
    }
    function showLevel(level) {
      Array.prototype.forEach.call(sheet.querySelectorAll('[data-bh-level]'), function (l) { l.hidden = l !== level; });
      sheet.scrollTop = 0;
    }
    function openDrawer(opener) {
      if (!drawer) return;
      lastOpener = opener || null;
      closeAllMegas(false);
      dismissSearch();
      drawer.hidden = false;
      showLevel(sheet.querySelector('[data-bh-level="root"]'));
      root.querySelectorAll('[data-bh-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      docEl.style.overflow = 'hidden';
      docEl.classList.add('bh-drawer-open');
      var closeBtn = sheet.querySelector('[data-bh-drawer-close]');
      (closeBtn || sheet).focus();
    }
    function closeDrawer() {
      if (!drawerOpen()) return;
      drawer.hidden = true;
      root.querySelectorAll('[data-bh-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      root.querySelectorAll('[data-bh-sub-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      docEl.style.overflow = '';
      docEl.classList.remove('bh-drawer-open');
      if (lastOpener && lastOpener.offsetParent !== null) lastOpener.focus();
    }
    if (drawer) {
      root.querySelectorAll('[data-bh-drawer-open]').forEach(function (b) {
        b.addEventListener('click', function () { openDrawer(b); });
      });
      drawer.querySelectorAll('[data-bh-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
      drawer.querySelectorAll('[data-bh-sub-open]').forEach(function (b) {
        b.addEventListener('click', function () {
          var sub = document.getElementById(b.getAttribute('aria-controls'));
          if (!sub) return;
          b.setAttribute('aria-expanded', 'true');
          showLevel(sub);
          var back = sub.querySelector('[data-bh-sub-back]'); if (back) back.focus();
        });
      });
      drawer.querySelectorAll('[data-bh-sub-back]').forEach(function (back) {
        back.addEventListener('click', function () {
          var sub = back.closest('[data-bh-level]');
          showLevel(sheet.querySelector('[data-bh-level="root"]'));
          var opener = sheet.querySelector('[aria-controls="' + sub.id + '"]');
          if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
        });
      });
    }
    api.onDesktopChange = function () { if (desktop.matches && !fixed) closeDrawer(); measure(); setHeaderVars(); };
    // Focus may not leave the open drawer: anything focused behind it sends focus back in
    api.onFocusIn = function (e) {
      if (!drawerOpen() || sheet.contains(e.target)) return;
      var f = visibleFocusables(); (f[0] || sheet).focus();
    };

    /* ---------- Search: model-aware suggestions ---------- */
    var input = form && form.querySelector('input[name="q"]');
    var panel = form && form.querySelector('[data-bh-search-panel]');
    var quick = form && form.querySelector('[data-bh-search-quick]');
    var status = form && form.querySelector('[data-bh-search-status]');
    var controller = null, timer = null, active = -1, options = [];
    function showQuick(show) { if (quick && quick.querySelector('a')) quick.hidden = !show; }
    function closePanel() {
      if (!panel) return;
      panel.hidden = true; panel.innerHTML = ''; options = []; active = -1;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }
    function dismissSearch() {
      clearTimeout(timer);
      if (controller) { controller.abort(); controller = null; }
      closePanel(); showQuick(false);
    }
    if (searchToggle) {
      searchToggle.addEventListener('click', function () {
        var open = !root.classList.contains('bh--search-open');
        root.classList.toggle('bh--search-open', open);
        setSearchToggle(open);
        setHeaderVars();
        if (open && input) input.focus(); else dismissSearch();
      });
    }
    if (form) {
      var suggestUrl = (form.getAttribute('data-suggest-url') || '/search/suggest') + '.json';
      var searchUrl = form.getAttribute('action') || '/search';
      var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';
      var money = function (value) {
        var n = Number(value);
        if (isNaN(n)) return '';
        var amount = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, amount);
      };
      var esc = function (s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      };
      var setActive = function (i) {
        if (!options.length) return;
        active = (i + options.length) % options.length;
        options.forEach(function (o, k) { o.setAttribute('aria-selected', k === active ? 'true' : 'false'); });
        input.setAttribute('aria-activedescendant', options[active].id);
        options[active].scrollIntoView({ block: 'nearest' });
      };
      var fullSearchHref = function (q) {
        return searchUrl + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q);
      };
      var render = function (q, data) {
        var res = (data && data.resources && data.resources.results) || {};
        var products = res.products || [], collections = res.collections || [];
        var html = '', idx = 0;
        if (products.length) {
          html += '<div role="group" aria-labelledby="bh-sr-g1"><p class="bh-sr-group" id="bh-sr-g1">Products</p>';
          products.forEach(function (p) {
            var img = p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=88" alt="" width="44" height="44" loading="lazy">' : '<span class="bh-sr__ph" aria-hidden="true"></span>';
            var right = p.available ? '<span class="bh-sr__price">' + esc(money(p.price)) + '</span>' : '<span class="bh-sr__soldout">Unavailable</span>';
            html += '<a class="bh-sr" role="option" tabindex="-1" aria-selected="false" id="bh-sr-' + (idx++) + '" href="' + esc(p.url) + '">' + img +
              '<span><span class="bh-sr__title">' + esc(p.title) + '</span>' + (p.vendor ? '<span class="bh-sr__meta">' + esc(p.vendor) + '</span>' : '') + '</span>' + right + '</a>';
          });
          html += '</div>';
        }
        if (collections.length) {
          html += '<div role="group" aria-labelledby="bh-sr-g2"><p class="bh-sr-group" id="bh-sr-g2">Categories</p>';
          collections.forEach(function (c) {
            html += '<a class="bh-sr bh-sr--plain" role="option" tabindex="-1" aria-selected="false" id="bh-sr-' + (idx++) + '" href="' + esc(c.url) + '"><span class="bh-sr__title">' + esc(c.title) + '</span><span class="bh-sr__meta">Category</span></a>';
          });
          html += '</div>';
        }
        html += '<a class="bh-sr-all" role="option" tabindex="-1" aria-selected="false" id="bh-sr-' + (idx++) + '" href="' + fullSearchHref(q) + '">See all results for “' + esc(q) + '”</a>';
        panel.innerHTML = html;
        options = Array.prototype.slice.call(panel.querySelectorAll('[role="option"]'));
        active = -1;
        input.removeAttribute('aria-activedescendant');
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        var n = products.length + collections.length;
        if (status) status.textContent = n ? n + (n === 1 ? ' suggestion' : ' suggestions') + ' available' : 'No suggestions. Press Enter to search.';
      };
      var suggest = function () {
        var q = input.value.trim();
        if (q.length < 2) { closePanel(); showQuick(document.activeElement === input); return; }
        showQuick(false);
        if (controller) controller.abort();
        controller = window.AbortController ? new AbortController() : null;
        var url = suggestUrl + '?q=' + encodeURIComponent(q) +
          '&resources%5Btype%5D=product,collection&resources%5Blimit%5D=6' +
          '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
          '&resources%5Boptions%5D%5Bfields%5D=title,vendor,product_type,variants.sku,variants.title';
        fetch(url, controller ? { signal: controller.signal } : {})
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) { if (input.value.trim() === q && document.activeElement === input) render(q, data); })
          .catch(function () { /* aborted or offline: the plain search form still works */ });
      };
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(suggest, 180); });
      input.addEventListener('focus', function () { if (input.value.trim().length < 2) showQuick(true); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' && options.length) { e.preventDefault(); setActive(active + 1); }
        else if (e.key === 'ArrowUp' && options.length) { e.preventDefault(); setActive(active < 0 ? options.length - 1 : active - 1); }
        else if (e.key === 'Enter' && active > -1 && options[active]) { e.preventDefault(); window.location.href = options[active].href; }
      });
      form.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (!panel.hidden || (quick && !quick.hidden)) { e.preventDefault(); e.stopPropagation(); dismissSearch(); input.focus(); }
      });
      // Pressing a suggestion must not blur the input first (Safari and macOS Firefox don't focus links on click)
      [panel, quick].forEach(function (el) { if (el) el.addEventListener('mousedown', function (e) { e.preventDefault(); }); });
      form.addEventListener('focusout', function (e) {
        if (form.contains(e.relatedTarget)) return;
        setTimeout(function () { if (!form.contains(document.activeElement)) dismissSearch(); }, 120);
      });
    }

    /* ---------- Document-level handlers (registered once, routed to the live header) ---------- */
    api.onKeydown = function (e) {
      if (drawerOpen()) {
        if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
        if (e.key !== 'Tab') return;
        var f = visibleFocusables(); if (!f.length) { e.preventDefault(); sheet.focus(); return; }
        var first = f[0], last = f[f.length - 1];
        if (!sheet.contains(document.activeElement) || document.activeElement === sheet) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
        else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        return;
      }
      if (e.key !== 'Escape') return;
      var open = toggles.filter(isOpen)[0];
      if (open) { e.preventDefault(); closeMega(open, root.contains(document.activeElement)); }
    };
    api.onClick = function (e) {
      if (!nav.contains(e.target)) closeAllMegas(false);
      if (form && !form.contains(e.target) && !(searchToggle && searchToggle.contains(e.target))) dismissSearch();
    };
    api.destroy = function () {
      if (drawerOpen()) { docEl.style.overflow = ''; docEl.classList.remove('bh-drawer-open'); }
      clearTimeout(timer);
      if (controller) controller.abort();
    };

    // Floating app widgets hide while any header overlay (mega panel, search panel, drawer) is open
    function syncOverlay() {
      var open = drawerOpen() || toggles.some(isOpen) || (!!panel && !panel.hidden) || (!!quick && !quick.hidden);
      docEl.classList.toggle('bh-overlay-open', open);
    }
    var overlayObserver = window.MutationObserver ? new MutationObserver(syncOverlay) : null;
    if (overlayObserver) overlayObserver.observe(root, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
    var destroyBase = api.destroy;
    api.destroy = function () { destroyBase(); if (overlayObserver) overlayObserver.disconnect(); docEl.classList.remove('bh-overlay-open'); };

    measure(); setHeaderVars(); onScroll();
    return api;
  }

  function init(root) {
    if (!root || root.dataset.bhReady) return;
    root.dataset.bhReady = '1';
    if (current) current.destroy();
    current = createHeader(root);
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking || !current) return;
    ticking = true;
    window.requestAnimationFrame(function () { ticking = false; if (current) current.onScroll(); });
  }, { passive: true });
  window.addEventListener('resize', function () { if (current) current.onResize(); });
  if (desktop.addEventListener) desktop.addEventListener('change', function () { if (current) current.onDesktopChange(); });
  document.addEventListener('keydown', function (e) { if (current) current.onKeydown(e); });
  document.addEventListener('click', function (e) { if (current) current.onClick(e); });
  document.addEventListener('focusin', function (e) { if (current) current.onFocusIn(e); });
  document.addEventListener('shopify:section:unload', function (e) {
    if (current && e.target.contains(current.root)) { current.destroy(); current = null; }
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-bh-root]')); });

  init(document.querySelector('[data-bh-root]'));
})();
